export default __webpack_public_path__ + "static/media/lock.60b69dc933a46d46de2f6646b63a2f99.svg";